import { CountryType } from '@/app/types/constantDataType'
import { sortByName } from '@/app/utils/formatListData'

export const getCompanyList = async (companyName: string) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/companies/search_by_name.json?name=${companyName}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          credentials: 'include',
        },
      }
    )
    const res = await response.json()
    return sortByName(res)
  } catch (error) {
    console.log(error)
    return []
  }
}

export const getProductList = async (
  productName: string,
  productFamily: string
) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/products/search?name=${productName}&product_family=${productFamily}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const res = await response.json()
    return sortByName(res.products) ?? []
  } catch (error) {
    console.log(error)
  }
}

export const getCityList = async (
  CityName: string,
  countryId: string,
  provinceId?: number,
  region?: string
) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/countries/${countryId}/search_city?name=${CityName}&province_id=${provinceId !== -1 && provinceId ? provinceId : ''}&country_region_id=${region ? region : ''}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const res = await response.json()
    return sortByName(res.cities) ?? []
  } catch (error) {
    console.log(error)
  }
}

export const getProvinceList = async (
  ProvinceName: string,
  countryId: string,
  region?: string
) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/province?country_id=${countryId}&name=${ProvinceName}${region && region !== '' ? `&country_region_id=${region}` : ''}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const res = await response.json()
    return sortByName(res.provinces) ?? []
  } catch (error) {
    console.log(error)
  }
}

export const getCountriesList = async (countryName: string) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/countries?name=${countryName}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const res = await response.json()
    return (
      sortByName(
        res?.filter((country: CountryType) => country?.name !== 'All countries')
      ) ?? []
    )
  } catch (error) {
    console.log(error)
  }
}

export const getRegionsList = async (
  country_id: string,
  regionName: string
) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/countries/${country_id}/search_country_region?name=${regionName}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const res = await response.json()
    return sortByName(res.country_regions) ?? []
  } catch (error) {
    console.log(error)
  }
}
